var exports = {
  "K": "CodeElements.module__icon___V1ZJdz",
};

module.exports = exports;
